import hark from 'hark';
import { useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

export default function SoundWave() {
    const soundAnimationRef = useRef(null);
    const [speaking, setSpeaking] = useState(false);

    useEffect(() => {
        addEventListener();
    }, []);

    const addEventListener = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            let options = {};
            let speechEvents = hark(stream, options);
            speechEvents.on('speaking', function () {
                setSpeaking(true);
            });

            speechEvents.on('stopped_speaking', function () {
                setSpeaking(false);
            });
        } catch {
            console.log('sound error');
        }
    };

    return (
        <CSSTransition nodeRef={soundAnimationRef} in={speaking} timeout={500} unmountOnExit classNames="fade">
            <div ref={soundAnimationRef}>
                <div className="boxContainer">
                    <div className="box box1"></div>
                    <div className="box box2"></div>
                    <div className="box box3"></div>
                    <div className="box box4"></div>
                    <div className="box box5"></div>
                </div>
            </div>
        </CSSTransition>
    );
}
